var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-result"},[_c('p',{staticClass:"p1"},[_vm._v("支付完成")]),_c('p',{staticClass:"p2"},[_vm._v("请返回微信继续操作")]),_c('button',{on:{"click":_vm.goWx}},[_vm._v("返回微信")])])}
var staticRenderFns = []

export { render, staticRenderFns }